import { IoMdCloudUpload } from "react-icons/io";

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useRef, useState, useEffect, useCallback } from "react";

import * as API from "../../service/api";
import * as CH from "../../service/customHook";
import * as APIURL from "../../service/string/apiUrl";
import * as TOA from "../../service/library/toast";
import * as IMGPROC from "../../service/library/imageProcessor";

import * as IMAGE from "../../action/image";

import ServicesImageOnClick from "./ServicesImageOnClick";
import Loading from "../piece/PieceLoading";

export default function ContractImgsSet({ disabled }) {
  const id = "contract_imgs";
  const dispatch = useDispatch();

  const getedData = useSelector((state) => state.data.getedData, shallowEqual);
  const contractImgs = useSelector(
    (state) => state.image.contractImgsData,
    shallowEqual
  );

  const [files, setFiles] = useState([]);
  const [hover, setHover] = useState(false);

  const dragRef = useRef(null);
  let [loading, setLoading] = useState(false);

  const fnState = (files) => {
    dispatch(IMAGE.serviceContractImgsData(files));
    return setLoading(false);
  };

  CH.useDidMountEffect(() => {
    if (!!getedData.contractImgs) {
      API.servicesPostData(APIURL.urlGetImages, {
        imgs: getedData.contractImgs,
      }).then((res) => {
        if (res.status === "success") {
          fnState(res.data);
          setFiles(res.data);
        }
      });
    }
  }, [getedData]);

  const onChangeFiles = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);

      let selectFiles = [];
      if (e.type === "drop") {
        selectFiles = e.dataTransfer.files;
      } else {
        selectFiles = e.target.files;
      }

      for (let i = 0; i < selectFiles.length; i++) {
        if (selectFiles[i].size > 20000000) {
          setLoading(false);
          return alert("20MB 용량 미만의 이미지만 등록 가능합니다.");
        }
      }

      if (contractImgs.length + selectFiles.length > 25) {
        setLoading(false);
        TOA.servicesUseToast("이미지는 최대 25개까지 입력하실 수 있습니다.");
        return;
      }

      try {
        const processedFiles = await IMGPROC.removeExifOrientationFromFiles(selectFiles);

        const formData = new FormData();
        for (let i = 0; i < processedFiles.length; i++) {
          formData.append("Imgs", processedFiles[i]);
        }

        API.servicesPostDataForm(APIURL.urlUpImages, formData).then((res) => {
          if (res.status === "success") {
            if (res.data.length == 1) {
              fnState([...contractImgs, res.data[0]]);
              setFiles((prev) => [res.data[0], ...prev]);
            } else if (res.data.length > 1) {
              const arrData = [];
              for (let i = 0; i < res.data.length; i++) {
                setFiles((prev) => [res.data[i], ...prev]);
                arrData.push(res.data[i]);
              }
              fnState([...arrData, ...contractImgs]);
            } else {
              setLoading(false);
              TOA.servicesUseToast("이미지가 업로드되지 않았습니다.", "e");
            }
          } else {
            setLoading(false);
            TOA.servicesUseToast("이미지가 업로드되지 않았습니다.", "e");
          }
        });
      } catch (error) {
        console.error("이미지 처리 중 오류:", error);
        setLoading(false);
        TOA.servicesUseToast("이미지 처리 중 오류가 발생했습니다.", "e");
      }
    },
    [contractImgs]
  );

  const handleFilterFile = useCallback(
    (iid) => {
      setFiles(files.filter((it) => it.iid !== iid));
      dispatch(
        IMAGE.serviceContractImgsData(contractImgs.filter((it) => it.iid !== iid))
      );
    },
    [files, contractImgs]
  );

  const handleDragIn = useCallback((e) => { e.preventDefault(); e.stopPropagation(); }, []);
  const handleDragOut = useCallback((e) => { e.preventDefault(); e.stopPropagation(); }, []);
  const handleDragOver = useCallback((e) => { e.preventDefault(); e.stopPropagation(); }, []);
  const handleDrop = useCallback(
    (e) => { e.preventDefault(); e.stopPropagation(); onChangeFiles(e); },
    [onChangeFiles]
  );

  const initDragEvents = useCallback(() => {
    if (dragRef.current !== null) {
      dragRef.current.addEventListener("dragenter", handleDragIn);
      dragRef.current.addEventListener("dragleave", handleDragOut);
      dragRef.current.addEventListener("dragover", handleDragOver);
      dragRef.current.addEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  const resetDragEvents = useCallback(() => {
    if (dragRef.current !== null) {
      dragRef.current.removeEventListener("dragenter", handleDragIn);
      dragRef.current.removeEventListener("dragleave", handleDragOut);
      dragRef.current.removeEventListener("dragover", handleDragOver);
      dragRef.current.removeEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  useEffect(() => {
    initDragEvents();
    return () => resetDragEvents();
  }, [initDragEvents, resetDragEvents]);

  return (
    <div className="setImageWrap">
      <div className="contractImgLabelWrap">
        <label className="blockLabel contractImgLabel">
          <span>계약관련 서류 첨부</span>
          <label className="contractImgUploadBtn" htmlFor={id} ref={dragRef}>
            파일업로드
          </label>
        </label>
      </div>

      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className="imgsThumbnail"
        style={
          disabled
            ? {
                backgroundColor: "rgba(239, 239, 239, 0.3)",
                height: files.length <= 10 ? "104px" : files.length <= 20 ? "196px" : "286px",
              }
            : {
                height: files.length <= 10 ? "104px" : files.length <= 20 ? "196px" : "286px",
              }
        }
      >
        <input
          type="file"
          id={id}
          style={{ display: "none" }}
          multiple={true}
          onClick={(e) => { e.target.value = null; }}
          onChange={onChangeFiles}
          disabled={disabled ? true : false}
        />
        <label
          htmlFor={id}
          ref={dragRef}
          className={hover ? "imgsUploadhover" : ""}
          style={{
            height: files.length <= 10 ? "94px" : files.length <= 20 ? "186px" : "288px",
          }}
        >
          <IoMdCloudUpload />
          <span>여기에 파일을</span>
          <span>끌어다 놓습니다.</span>
        </label>

        <div
          className="DragDrop-Files"
          style={{
            border: files.length == 0 ? "none" : "2px dotted rgba(0, 0, 0, 0.1)",
          }}
        >
          <Loading loading={loading} />

          {files.length > 0 &&
            !!contractImgs &&
            files.map((item, index) => (
              <ServicesImageOnClick
                key={item && item.iid}
                url={item}
                text="계약서류"
                iid={item && item.iid}
                onRemove={() => handleFilterFile(item.iid)}
                id={id}
                disabled={disabled ? true : false}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
